<div class="modern-dialog-container">
  <!-- Drag handle for bottom sheet -->
  <div class="drag-handle-container">
    <div class="drag-handle"></div>
  </div>
  
  @if (showForm) {
    <!-- Form view -->
    <div class="dialog-header">
      <h3 class="dialog-title" [innerHtml]="title"></h3>
    </div>
    
    <div class="dialog-content">
      <form [formGroup]="form">
        @if (userAction === 'no') {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>To (month, year)</mat-label>
            <input
              id="empTo"
              matInput
              [matDatepicker]="toDatePicker"
              [max]="maxToDate"
              [min]="minToDate"
              formControlName="toDate"
              required
              (click)="onDatePickerClick(toDatePicker)"
              onkeydown="return false;"
              readonly
              />
            <mat-datepicker-toggle matIconSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <mat-datepicker
              #toDatePicker
              startView="multi-year"
              touchUi="true"
              (monthSelected)="chosenMonthHandler($event, toDatePicker, form, 'toDateControl')"
              >
            </mat-datepicker>
            @if (toDate.touched && toDate.invalid) {
              <mat-error>
                {{ getToDateErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
        }
        @if (isEmailNeeded) {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Reference Email</mat-label>
            <input
              matInput
              type="email"
              formControlName="referenceEmail"
              required
              data-test="reference-email-form-field"
              />
            @if (referenceEmail.touched && referenceEmail.invalid) {
              <mat-error>
                {{ getReferenceEmailErrorMessage() }}
              </mat-error>
            }
          </mat-form-field>
        }
      </form>
    </div>
    
    <div class="dialog-actions">
      <button mat-button class="modern-cancel-button" type="button" (click)="updateShowForm(false)">
        Back
      </button>
      <button mat-button class="modern-confirm-button" type="button" [disabled]="form.invalid" (click)="submitForm()">
        Confirm
      </button>
    </div>
  } @else {
    <!-- Confirmation view -->
    <div class="dialog-header">
      <div class="icon-container">
        <mat-icon svgIcon="alert-circle" class="warning-icon"></mat-icon>
      </div>
    </div>
    
    <div class="dialog-content">
      <p class="dialog-message" [innerHtml]="title"></p>
    </div>
    
    <div class="dialog-actions">
      <button mat-button class="modern-cancel-button" (click)="updateUserAction('no')">
        No
      </button>
      <button mat-button class="modern-confirm-button" type="button" (click)="updateUserAction('yes')">
        Yes
      </button>
    </div>
  }
</div>
